import AdditionCounter from './AdditionCounter';
import type { AdditionOption } from '../../types/@types/product';

export default function AdditionsGroup({
  options,
  value,
  onChange,
}: {
  options: AdditionOption[];
  value: Record<string, number>;
  onChange: (key: string, qty: number) => void;
}) {
  return (
    <div className="space-y-2">
      {options
        .filter((o) => o.active)
        .map((opt) => {
          const qty = value[opt.key] ?? 0;
          return (
            <AdditionCounter
              key={opt.key}
              label={`${opt.name} (+$${opt.priceDelta})`}
              qty={qty}
              maxQty={opt.maxQty}
              onInc={() => onChange(opt.key, Math.min(opt.maxQty, qty + 1))}
              onDec={() => onChange(opt.key, Math.max(0, qty - 1))}
            />
          );
        })}
    </div>
  );
}
